import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary"]
  static values = { hasErrors: Boolean }

  connect() {
    if (!this.hasErrorsValue) return

    window.requestAnimationFrame(() => this.focusFirstError())
  }

  focusFirstError() {
    const field = this.element.querySelector(
      "input.error:not([type='hidden']), select.error, textarea.error, [aria-invalid='true']:not([type='hidden'])"
    )
    const target = field || (this.hasSummaryTarget ? this.summaryTarget : null)
    if (!target) return

    target.scrollIntoView({ behavior: "smooth", block: "center" })
    target.focus({ preventScroll: true })
  }
}
